 <template>
    <div class="content-style">                  
        <v-main class="pt-0">
            <section id="main">
                <!-- Hero -->

                <v-card 
                    tile
                    class="elevation-0 d-flex align-center hero__signup2"                    
                    min-height="50vh"
                    width="100vw"                
                >
                    <v-container :fluid="$vuetify.breakpoint.mdAndUp" class="hero__container" :class="$vuetify.breakpoint.mdAndDown ? 'mb-0 ' : ''" >
                        <v-row align="center">
                            <div v-if="$vuetify.breakpoint.xs">
                                <v-col cols="12" class="pl-8">
                                    <v-img :class="$vuetify.breakpoint.smAndUp ? 'mb-16' : 'mb-2'" src="/logo_blanc.png" contain max-width="250" alt="inmatic"></v-img>
                                </v-col>
                                <v-col cols="12" class="pl-8 pb-0">
                                    <h1 class="white--text hero__title">
                                    Reduce tu proceso contable <br><strong class="hero__title-bold">en más del 70%</strong>
                                    </h1>
                                </v-col>
                            </div>  
                            <v-col cols="1" v-if="$vuetify.breakpoint.smAndUp"></v-col>
                            <v-col cols="10" sm="7" md="7" lg="7" xl="6" :class="{'pl-8': $vuetify.breakpoint.xs, 'pt-0': $vuetify.breakpoint.xs}">
                                <v-row>
                                    <v-col cols="12" v-if="$vuetify.breakpoint.smAndUp">
                                    <v-img :class="$vuetify.breakpoint.smAndUp ? 'mb-16' : 'mb-2'" src="/logo_blanc.png" contain max-width="250" alt="inmatic"></v-img>
                                    </v-col>
                                    <v-col cols="12" v-if="$vuetify.breakpoint.smAndUp">
                                        <h1 class="white--text hero__title">
                                        Reduce tu proceso contable<br> <strong class="hero__title-bold">en más del 70%</strong>
                                        </h1>
                                    </v-col>
                                    <v-col cols="12">
                                        <p class="white--text hero__text">
                                            <strong class="hero__text-bold">Ahorra tiempo</strong> en todo el proceso contable mediante la automatización y nuestra Inteligencia Artificial.                                                                         
                                        </p>
                                        <p class="white--text hero__text mb-0">
                                            Con la máxima fiabilidad.
                                        </p>                                    
                                    </v-col>
                                    <v-col cols=12 class="d-flex" :class="{'flex-column':$vuetify.breakpoint.smAndDown}">
                                        <v-btn 
                                            rounded
                                            color="#1bbff7"
                                            elevation="0"                                            
                                            class="px-6 font-weight-bold white--text btn__hero__cta"    
                                            href="#signup-form">
                                            PRUÉBALO GRATIS
                                        </v-btn>                                             
                                        <div class="white--text link__how_it_work mt-1" 
                                        :class="{'mt-5':$vuetify.breakpoint.smAndDown, 'ml-5': $vuetify.breakpoint.mdAndUp}" 
                                        v-on:click="tooglePopupVideoVisibility">                                            
                                            Descubre cómo funciona
                                            <v-icon color="#1bbff7" right>
                                                mdi-chevron-triple-right
                                            </v-icon>                                            
                                        </div>                                              
                                    </v-col>                                                                                                      
                                </v-row>
                            </v-col >                                                                              
                        </v-row>
                    </v-container>
                </v-card>
                <!-- / Hero -->

                <!-- Video Popup -->
                <div id="light-popup-video" v-if="isPopupVideoVisible">
                    <a id="close-popup" v-on:click="tooglePopupVideoVisibility"></a>
                    <video id="video-inmatic" controls>                         
                        <source src="https://inmatic-newsletter.s3.eu-west-1.amazonaws.com/Inmatic+tu+robot+contable.mp4" type="video/mp4">
                        <!--Browser does not support <video> tag -->
                    </video>
                </div>
                <div id="fade-popup" v-if="isPopupVideoVisible" v-on:click="tooglePopupVideoVisibility"></div>
                <!-- /Video popup -->

                <v-card tile class="elevation-0" :class="{'mt-16': $vuetify.breakpoint.mdAndUp}"  width="100vw">
                    <v-container :fluid="true">
                        <v-row >
                            <v-col lg="1" v-if="$vuetify.breakpoint.xlOnly"></v-col>
                            <v-col lg="6" xl="5" sm="12" xs="12" md="6" v-if="$vuetify.breakpoint.mdAndUp">
                                <v-row>
                                    <v-col v-if="$vuetify.breakpoint.lgAndUp" cols="2"></v-col>
                                    <v-col :cols="$vuetify.breakpoint.lgAndUp ? 9:12">
                                        <v-container :fluid="true" :class="{'pl-5':$vuetify.breakpoint.mdAndDown}">
                                            <div>
                                                <div :class="{'text-h3':$vuetify.breakpoint.mdAndUp,'text-h5':$vuetify.breakpoint.smAndDown}" class="new__primary font-weight-bold mt-5 mb-5">
                                                    Crea tu usuario y empieza a ser más productivo
                                                </div>
                                                <p class="mb-5">Empieza la transformación de tu proceso contable a <b>golpe de click</b>. Evita dedicar horas a <b>procesar facturas que se envían a última hora y que os cargan de trabajo</b>, especialmente en los cierres de trimestre.</p>
                                                <p class="mb-2">Olvídate de picar facturas. Empieza <b>a agilizar tus procesos</b> con el robot contable de Inmatic y consigue <b>mejorar la productividad de tu equipo</b>, además de <b>acelerar</b> esos interminables <b>cierres trimestrales</b>.</p>                                                
                                            </div>
                                        </v-container>
                                    </v-col>
                                    <v-col cols="1" v-if="$vuetify.breakpoint.lgAndUp" ></v-col>
                                </v-row>
                            </v-col>
                            <v-col lg="6" xl="5" sm="12" xs="12" md="6" class="pt-0">
                                <div :class="{'mt-6': $vuetify.breakpoint.smAndUp}">                                    
                                    <v-card 
                                        color="#F2F1FF"
                                        elevation="0" 
                                        width="400" 
                                        class="mx-auto pa-5 rounded-xl card__signup__form" 
                                        :class="{'mt-5': $vuetify.breakpoint.smAndUp}"
                                    >
                                        <v-card-subtitle class="violet--text mt-2 mb-4" v-if="$vuetify.breakpoint.mdAndUp">Disfruta de tu <strong><br>periodo de prueba gratuito</strong></v-card-subtitle>
                                        <v-card-subtitle class="violet--text mt-2 mb-3 text-center" v-if="$vuetify.breakpoint.smAndDown"><strong>Crea tu usuario y empieza a ser más productivo</strong></v-card-subtitle>
                                        <v-card-text class="pb-0"> 
                                            <v-form id="signup-form">
                                                <v-text-field 
                                                    label="Usuario" 
                                                    prepend-inner-icon="mdi-account-circle" 
                                                    v-model="username"
                                                    solo
                                                    flat                                                    
                                                    color="#66369B"                                                   
                                                    background-color="#FFFFFF"
                                                    @keyup="usernameToLowerCase"
                                                />
                                                <v-text-field 
                                                    label="Email" 
                                                    prepend-inner-icon="mdi-email" 
                                                    v-model="email" 
                                                    solo
                                                    flat
                                                    color="#66369B"   
                                                    background-color="#FFFFFF"    
                                                    type="email" 
                                                    :error="error_email"                                                                                                                      
                                                />
                                                <v-text-field 
                                                    label="Repetir Email" 
                                                    prepend-inner-icon="mdi-email-check" 
                                                    v-model="email2" 
                                                    solo
                                                    flat
                                                    color="#66369B"   
                                                    background-color="#FFFFFF"    
                                                    type="email" 
                                                    :error="error_email2"
                                                    @paste.prevent
                                                    @click.right.prevent                                                                                                                      
                                                />
                                                <v-text-field
                                                    solo
                                                    flat
                                                    color="#66369B" 
                                                    background-color="#FFFFFF"
                                                    :type="showPassword ? 'text' : 'password'"
                                                    label="Contraseña"
                                                    prepend-inner-icon="mdi-lock"
                                                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                                    v-model="password"
                                                    @click:append="showPassword = !showPassword"
                                                    v-on:keyup.enter="signup"
                                                />
                                                <div class="d-flex justify-center">
                                                    <v-checkbox                                                    
                                                        v-model="privacyAccepted"                                                    
                                                        hide-details
                                                        class="mt-0 mb-3 checkbox__terms"
                                                        color="#66369B"
                                                    >
                                                        <template v-slot:label>
                                                            <div class="font-weight-light pl-1 pr-1">
                                                            He leído y acepto la
                                                            <v-tooltip location="bottom">
                                                                <template v-slot:activator="{ props }">
                                                                <a
                                                                    target="_blank"
                                                                    rel="noopener"
                                                                    class="font-weight-light text-decoration-underline"                    
                                                                    href="https://inmatic.ai/legal/politica-de-privacidad/"
                                                                    v-bind="props"
                                                                    @click.stop
                                                                >
                                                                    política de privacidad
                                                                </a>
                                                                </template>
                                                                Abrir en nueva ventana
                                                            </v-tooltip>
                                                            </div>
                                                        </template>
                                                    </v-checkbox>
                                                </div>
                                                
                                                <p v-if="error" class="red--text">{{error}}</p>
                                            </v-form>
                                        </v-card-text>
                                        <v-divider></v-divider>
                                        <v-card-actions>                                            
                                            <v-btn 
                                                rounded
                                                elevation="0"
                                                class="btn__signup font-weight-bold white--text mb-2 mx-auto px-6 py-6" 
                                                color="#050d4c" 
                                                :loading='loading' 
                                                @click="signup"
                                            >
                                                CREAR USUARIO
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </div>
                            </v-col>
                            
                        </v-row>
                    </v-container> 
                </v-card>
                <v-row no-gutters justify="center" style="background-color: #FFFFFF">
                    <div class="triangle"></div>
                </v-row>
            </section>
            <section id="why_inmatic">
                <v-container :fluid="true" >
                    <v-row class="mb-3 pt-6">
                        <v-col class="text-center">
                            <h4 class="white--text">¿Por qué Inmatic?</h4>
                        </v-col>
                    </v-row>
                    <v-row >
                        
                        <v-col lg="4" xl="4" sm="6" cols="12" md="4" class="text-center">
                            <v-container :fluid="true" class="pt-0 dcontainer">
                                <v-img class="mx-auto mb-5" src="/signup_bullet_1.webp" contain max-width="80" alt="inmatic"></v-img>
                                <p class="white--text"><b>Ahorra tiempo</b><br v-if="$vuetify.breakpoint.mdAndUp"/> evitando tareas manuales, contabilizando las facturas de forma automática.</p>
                            </v-container>
                        </v-col>
                        <v-col lg="4" xl="4" sm="6" cols="12" md="4" class="text-center">
                            <v-container :fluid="true" class="pt-0 dcontainer">
                                <v-img class="mx-auto mb-5" src="/signup_bullet_2.webp" contain max-width="80" alt="inmatic"></v-img>
                                <p class="white--text"><b>Digitaliza tus facturas</b><br v-if="$vuetify.breakpoint.mdAndUp"/> y genera tus asientos contables automáticamente. ¡Así de fácil!</p>
                            </v-container>
                        </v-col>
                        <v-col cols="3" class="text-center" v-if="$vuetify.breakpoint.sm"></v-col> 
                        <v-col lg="4" xl="4" sm="6" cols="12" md="4"  class="text-center">
                            <v-container :fluid="true" class="pt-0 dcontainer">
                                <v-img class="mx-auto mb-5" src="/signup_bullet_3.webp" contain max-width="80" alt="inmatic"></v-img>
                                <p class="white--text"><b>Aumenta tu productividad</b><br v-if="$vuetify.breakpoint.mdAndUp"/> evitando errores y dedícate a aumentar tu cartera de clientes.</p>
                            </v-container>
                        </v-col> 
                        <v-col cols="3" class="text-center" v-if="$vuetify.breakpoint.sm"></v-col>                       
                        
                    </v-row>
                </v-container>
            </section>
            <app-footer-public/>
        </v-main>
        
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import AppFooterPublic from "@/components/layout/AppFooterPublic";

export default {
    name: 'SignUpPage',
    components: {
        AppFooterPublic,
    },
    data() {
        return {
            showPassword: false,    
            username:'',
            email:'',
            email2:'',
            password:'',
            privacyAccepted: false,    
            error: '',
            loading: false,            
            scrollPosition: null,
            isPopupVideoVisible:false,
        }
    },
    metaInfo: {
        title: 'Crear cuenta - Inmatic',
        titleTemplate: null,
        meta: [
            {name: 'description', content: 'Crea tu usuario en Inmatic y empieza a contabilizar tus facturas sin esfuerzo gracias a nuestra IA. ¡Pruébalo gratis!'},
            {name: 'robots', content: 'noindex'},
        ],  
    },
    computed: {
        ...mapState([
            'currentCompany',
        ]),        
        error_email(){            
            if (this.email) {
                let re = /^[\w-\.]+@([\w-]+\.)+[\w]{2,3}$/        
                return !re.test(this.email);
            } else {        
                return false;
            }
        },
        error_email2(){            
            if (this.email2) {
                let re = /^[\w-\.]+@([\w-]+\.)+[\w]{2,3}$/        
                return !re.test(this.email2);
            } else {        
                return false;
            }
        },          
    },
    mounted(){
        this.changeCrispColor("light_blue");
        window.addEventListener('scroll', this.updateScroll);
    },
    beforeDestroy(){
        this.changeCrispColor("deep_purple");
    },
    methods: {
        ...mapActions({
            textToLowerCase: "config/textToLowerCase",
        }),        
        usernameToLowerCase() {
            this.textToLowerCase(this.username).then((res) => {
                this.username = res;
            }).catch(err => {
                console.error(err);
            });
        },
        isFormCorrect() {
            let isCorrect = true;
            let re = /^[\w-\.]+@([\w-]+\.)+[\w]{2,3}$/
            let username_re = /^[a-zA-Z0-9-_@.]+$/
            if (this.username.length <= 0) {
                isCorrect = false;
                this.error = 'No se ha introducido usuario';
            } else if (this.email.length <= 0) {
                isCorrect = false;
                this.error = 'No se ha introducido el email';
            } else if (!re.test(this.email)) {
                isCorrect = false;
                this.error = 'Email introducido no es valido';
            } else if (this.email != this.email2) {
                isCorrect = false;
                this.error = 'Los emails introducidos no son iguales';         
            } else if (this.password.length <= 0) {
                isCorrect = false;
                this.error = 'No se ha introducido la contraseña.'
            } else if (this.password.length < 8) {
                isCorrect = false;
                this.error = 'La contraseña debe tener un mínimo de 8 caracteres.' 
            } else if (this.username.includes(' ') || this.password.includes(' ')) {
                isCorrect = false;
                this.error = 'Ni el nombre de usuario, ni la contraseña pueden contener espacios.'
            } else if (!username_re.test(this.username)) {
                isCorrect = false;
                this.error = 'Usuario invalido, no se permiten los caracteres introducidos'; 
            } else if (!this.privacyAccepted){
                isCorrect = false;
                this.error = 'Debe aceptar la política de privacidad' 
            }
            return isCorrect;
        },
        tooglePopupVideoVisibility(){
            return this.isPopupVideoVisible = !this.isPopupVideoVisible
        },
        async signup() {
            if (this.isFormCorrect()) {
                this.loading = true;
                try {
                    const resp = await this.signUpUser({
                        username: this.username,
                        email: this.email,
                        password: this.password
                    });
                    if (resp.data.signed) {
                        const result = await this.signInUser({
                            username: this.username,                            
                            password: this.password
                        });
                        this.loading = false;
                        this.setJWTToken(result);
                        this.setAfterLogged().then(() => {
                            this.$router.push(this.currentCompany.id + "/documents");
                        }).catch(err => { 
                            console.error(err);
                            this.$router.push("documents");
                        });
                    } else {
                        this.loading = false;
                        let err = resp.data['error'];
                        if (err.includes('UsernameExistsException')) {
                            this.error = 'Ya existe otro usuario con este nombre.'
                        } else if (err.includes('EmailExistsException')) {
                            this.error = 'Ya existe otro usuario con este email.'
                        } else {
                            this.error = 'No se ha podido crear el usuario.'
                        }
                    }
                } catch (error) {
                    this.loading = false;
                    this.error = error.message;
                }
            }
        },
        updateScroll() {
            this.scrollPosition = window.scrollY
        },        
        ...mapActions(["signUpUser", "signInUser", "setJWTToken", "setAfterLogged","changeCrispColor"]), 
    }
}
</script>

<style scoped>
    .content-style {
        /* background: -webkit-gradient(linear, left top, right top, from(#33ccff), color-stop(30%, #663399)) !important; */
        /* background: linear-gradient(to right, #33ccff 0%, #663399 30%) !important; */
        height: 100%;      
    }
    .hero__signup2 {
        background-image: url('/signup_hero_bg.webp');
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        position:relative;      
    }

    .hero__signup2 .hero__container {
        padding-top: 100px;
        padding-bottom:15px;
    }
    .btn__hero__cta {
        max-width: 200px;
    }

    .hero__signup2 .hero__title {
        font-size: 3rem;
        font-weight: lighter;
        font-family: "Kanit",sans-serif;
        line-height: 60px;
    }
    .hero__signup2 .hero__title .hero__title-bold {
        font-weight: bold;
    }
    .hero__signup2 .hero__text {
        font-size:20px;
        font-family: "Roboto", sans-serif !important;
    } 
    .link__how_it_work {
        font-style: italic;
        cursor:pointer;
        font-family: "Roboto", sans-serif !important;
    }
    .link__how_it_work a {
        color:#FFFFFF;
        text-decoration: none;
    }
    #light-popup-video {
        /*display: none;*/
        position: fixed;
        top: 50%;
        left: 50%;        
        max-width: 600px;
        max-height: 360px;
        margin-left: -300px;
        margin-top: -180px;
        /*background: #FFF;*/
        z-index: 1002;
        overflow: visible;
    }
    #light-popup-video video {
        width: 600px;
    }
    #fade-popup {
        /*display: none;*/
        position: fixed;
        top: 0%;
        left: 0%;
        width: 100%;
        height: 100%;
        background-color: black;
        z-index: 1001;
        -moz-opacity: 0.8;
        opacity: .80;
        filter: alpha(opacity=80);
    }
    #close-popup {
        float: right;
        cursor: pointer;
        color: #fff;
        border: 1px solid #AEAEAE;
        border-radius: 3px;
        background: #222222;
        font-size: 25px;
        font-weight: bold;
        display: inline-block;
        line-height: 0px;
        padding: 10px 3px;
        position: absolute;
        right: 2px;
        top: 2px;
        z-index: 1002;
        opacity: 0.9;
    }

    #close-popup:before {
        content: "×";
    }
    .card__signup__form .v-card__subtitle {
        font-size:22px;
        text-align: center;
    }
    .violet--text {
        color:#66369B !important;
    }
    #signup-form {
        scroll-margin-top: 220px;
    }
    >>>.checkbox__terms .v-label{
        font-size:14px !important;
    }
    .new__primary {
        color: #050D4C !important;
    }
    .triangle {
        width:0;
        height:0;
        border-right: 50px solid transparent;
        border-bottom: 50px solid #050D4C;
        border-left: 50px solid transparent;
    }
    #why_inmatic {
        font-size: 25px;
        background-color: #050D4C;      
        padding-top:20px;
        padding-bottom:160px;
    }
    #why_inmatic h4 {
    font-family: "Kanit", sans-serif;
    font-size: 30px;
    }
    #why_inmatic p {
        font-size:22px;
        font-family: "Roboto",sans-serif !important;
    }
    @media screen and (max-width: 600px) {   
        .hero__signup2 .hero__container {
            padding-top: 50px;
        }
        .hero__signup2 .hero__title {
            font-size: 1.4rem;
            line-height: 28px;
        }  
        .hero__signup2 .hero__text {
            font-size:16px;
        }      
        .link__how_it_work {
            font-size: 13px;
        }
        .link__how_it_work .v-icon {  
            font-size:18px;            
        }
        .link__how_it_work .v-icon--right {
            margin-left: 2px;
        }
        #light-popup-video {
            margin-left:0px;
            left:0;
        }
        #light-popup-video video {
            width:100%;
        }  
        .card__signup__form .v-card__subtitle {
            font-size:18px;
        }
        #why_inmatic h4 {
            font-size:22px;
        }
        #why_inmatic p {
            font-size:16px;
            text-align:left;
            margin-left:10px;            
        }
        #why_inmatic .dcontainer {
            display:flex;
            flex-direction: row;
            width: 95%;
        }
    }
    @media screen and (min-width: 600px) {
        .hero__signup2 .hero__container {          
            padding-bottom:50px;
        }
    }
    @media screen and (min-width: 960px) {
        .hero__signup2 .hero__container {
            padding-top: 140px;        
        }
    }
    @media screen and (min-width: 600px) and (max-width: 960px) {
        .hero__signup2 .hero__title {
            font-size: 1.8rem;
            line-height: 35px;
        }
        #why_inmatic p {
            font-size:20px;
        }
    }
    @media screen and (min-width: 960px) and (max-width: 1264px) {
        .hero__signup2 .hero__title {
            font-size: 2.5rem;
            line-height: 45px;
        }
    }

    .v-application .text-h3, .v-application .text-h4 {
        font-weight: 400;
        font-family: "Kanit",sans-serif!important;
    }
    .v-application .text-h5, .v-application .text-h6 {
        line-height: 2rem;
        font-family: "Kanit",sans-serif!important;
    }
    .v-application p {
        font-family: "Roboto",sans-serif!important;
    }
    .v-application {
        font-family: "Roboto",sans-serif; 
        line-height: 1.5;
    }
    .v-application .text-body-1 {
        font-size: 1rem!important;
        font-weight: 400;
        line-height: 1.5rem;
        letter-spacing: .03125em!important;
        font-family: "Roboto",sans-serif!important;
    }    
    .dcontainer {
        width:80%;
    }
    hr {
        border-color: transparent !important;
    }
    .v-btn{
        text-transform:none;
    }
    .v-btn.btn__signup {
        width: 100%;
        max-width: 280px;
    }
    .wrapper{
    position: relative;
    }
</style>
